import { FORTA_BLACK } from '../../../../../utils/colors';
import { TREATMENT_SERVICE_FIELD_HEIGHT } from './constants';

import type { SxProps, Theme } from '@mui/material';

export const TREATMENT_SERVICE_ROW_SX = {
  px: 1.25,
  py: 0.5,
  gap: 1.25,
};

export const TREATMENT_SERVICE_LABEL_SX: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  minHeight: { md: TREATMENT_SERVICE_FIELD_HEIGHT },
  flexBasis: { md: '37%' },
  flexShrink: 0,
  color: FORTA_BLACK,
  fontSize: 14,
};

export const TREATMENT_CONCLUDE_BUTTON_SX: SxProps<Theme> = {
  width: 160,
  height: 40,
  borderRadius: '8px',
};
